import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    model: String,
    hash: String
  }

  connect() {
    console.log('connecting errors')
    let model = this.modelValue

    const errors_container = $("#form-errors-container")
    errors_container.hide()
    errors_container.html('')

    // If there is no model passed, skip processing
    if (model.length > 0 && this.hashValue.length > 0) {
      let errors = JSON.parse(decodeURIComponent(this.hashValue))
      console.log(model)

      $('.form-row').removeClass('error').find('.message').removeClass('error').html('');

      $.each(errors, function(key, value) {
        if (key == 'message') {
          var $error_div = $('<div></div>');

          $error_div.html(value)

          $("#form-errors-container").append($error_div);
        } else {
          let selector_string = '[name="' + model + '[' + key + ']"]';
          let selector_string_of_array = '[name="' + model + '[' + key + '][]"]';
          let $input = $(selector_string);

          if ($input.length == 0) $input = $(selector_string_of_array);

          if ($input.length > 0) {
            var input_id = $input.attr('id');

            $input
              .closest('.form-row')
              .addClass('error')
              .find('.message')
              .addClass('error')
              .attr('id', input_id + '_alert')
              .html(value.join('<br>') );

            $input.attr('aria-describedby', input_id + '_alert');
          } else {
            var $error_div = $('<div></div>');
            // In case we don't have a specific field for the error
            // display it at the top of the form.
            // TODO: stylize
            $error_div.html(key + ": " + value)
            $error_div.addClass("message").addClass("error")

            errors_container.append($error_div);
          }
        }
      });

      // If it's in a tab
      var form_row = document.querySelector('.form-row.error')
      var tab_panel = form_row.closest('[data-pc-name="tabpanel"]')
      var tab_link_id = tab_panel.attributes['aria-labelledby'].value;
      var tab_link = tab_panel.closest('[data-pc-name="tabs"]').querySelector(`#${tab_link_id}`)

      tab_link.click()

      setTimeout(function() {
        form_row.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 100)
    }
    // Hide when empty to avoid CSS-induced height on unused error container
    errors_container.toggle($("#form-errors-container").children().length > 0);
  }
}
